import { HStack, Select, Text, useColorMode, VStack } from "@chakra-ui/react";
import PrimaryCard from "../common/cards/PrimaryCard";
import React, { useCallback, useMemo } from "react"
import { Trans, useTranslation } from "react-i18next";

const SettingsCard = () => {
    const { t } = useTranslation();
    const { colorMode, toggleColorMode } = useColorMode()

    const handleColorModeChange = useCallback((event) => {
        if (event?.target?.value !== colorMode) {
            toggleColorMode();
        }
    }, [colorMode, toggleColorMode]);

    const optionTextColor = useMemo(() => colorMode === "dark" ? "white" : "black", [colorMode]);

    return (
        <PrimaryCard title={t("plugin.settings.title")}>
            <VStack padding={"10px"}>
                <HStack>
                    <Text><Trans>plugin.settings.theme</Trans></Text>
                    <Select value={colorMode} onChange={handleColorModeChange}>
                        <option value={"light"} style={{ color: optionTextColor }}>{t(`plugin.settings.light`)}</option>
                        <option value={"dark"} style={{ color: optionTextColor }}>{t(`plugin.settings.dark`)}</option>
                    </Select>
                </HStack>
            </VStack>
        </PrimaryCard>
    );
};

export default React.memo(SettingsCard);
